import { _ } from "../../../../core/polyglot/polyglot.js";
import AbstractPeriodReportEvent from "./AbstractPeriodReportEvent.js";

/**
 * An `AcknowledgeEvent` is logged when a company user confirms having read and understood a report.
 */
export default class AcknowledgeEvent extends AbstractPeriodReportEvent {
	isAcknowledgeBy(user) {
		return user.getUsername() === this._author.getUsername();
	}

	isAcknowledged() {
		return true;
	}

	getLabel() {
		return _("Acknowledged");
	}

	static getType() {
		return "Acknowledge";
	}
}
